import React from 'react';
import {
  Route,
  Redirect
} from './Routing';
import {isSignedIn} from '../services/authService';


const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isSignedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/routing/PrivateRoute.js